module.exports = __webpack_public_path__ + "src/assets/img/07_jahr2000.c3724440.svg";